import React from "react";

import Table from "../../../common/Table";

import { Link } from "react-router-dom";

const BenefitFacultiesList = ({ data, query, match }) => {
  const { benefit } = match.params;

  const renderLink = (e) => {
    return (
      <Link to={`/mis/teacherBenefits/${benefit}/faculties/${e.faculty_id}`}>{e.faculty}</Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    { path: "faculty", label: "پوهنحی" , content: (e) => renderLink(e) },
    { path: "benefit", label: "امتیاز" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default BenefitFacultiesList;
